import { renderColorPrimary } from "@/common/function/FunctionTheme";
import styled from "styled-components";

export const TreeSelectBaseWrapper = styled.div<{
  $width?: number;
  $theme?: string;
  $isSmall?: boolean;
}>`
  position: relative;
  opacity: 1;
  width: 100%;
  .width_custom_popover {
    width: ${(props) => (props.$width ? props.$width - 32 : "300px")};
  }

  .fui-Checkbox__indicator {
    width: 12px !important;
    height: 12px !important;
  }

  .box-shadow-none {
    box-shadow: none !important;
  }

  .lbl_hide {
    display: none !important;
  }

  .input-locations-sl {
    width: 100%;
  }

  .input-locations-sl > input {
    color: ${(props) => renderColorPrimary(props.$theme)};
  }

  .active-location-tree > input {
    font-weight: 500;
  }

  .button-group-tree-location,
  .button-group-tree-location * {
    box-sizing: border-box;
  }

  .button-group-tree-location {
    background: #ffffff;
    border-radius: 0px 0px 2px 2px;
    border-style: solid;
    border-color: #c8c8c8;
    border-width: 0.5px 0px 0px 0px;
    width: 100%;
    height: 40px;
    position: relative;
    overflow: hidden;
  }

  .button-box-footer {
    background: #edebe9;
    width: 283.88px;
    height: 0.88px;
    position: absolute;
    left: 11.06px;
    top: -3.5px;
  }

  .frame-427322822 {
    display: flex;
    flex-direction: row;
    gap: 12px;
    align-items: center;
    justify-content: flex-start;
    position: absolute;
    right: 0px;
    top: 6px;
  }

  .reset-tree-location {
    color: #106ebe;
    text-align: left;
    font: 400 14px/20px "Segoe UI", sans-serif;
    text-decoration: underline;
    position: relative;
    cursor: pointer;
  }

  .frame-44 {
    background: #106ebe;
    border-radius: 2px;
    padding: 4px 12px 4px 12px;
    display: flex;
    flex-direction: row;
    gap: 8px;
    align-items: flex-start;
    justify-content: flex-start;
    flex-shrink: 0;
    position: relative;
  }

  .apply-tree-location {
    color: #ffffff;
    text-align: left;
    font: 600 14px/20px "Segoe UI", sans-serif;
    position: relative;
    cursor: pointer;
  }

  .input-locations-sl > input {
    &:hover {
      cursor: pointer;
    }
  }

  .pd-list {
    padding: 4px !important;
  }

  .size-small input {
    font-size: 12px;
    padding-left: 4px;
  }

  .size-small .fui-Input__contentBefore {
    margin-left: 3px;
  }

  .size-small .icon-horizontal {
    transform: rotate(270deg);
  }

  .size-small .fui-Label {
    font-size: 12px !important;
  }

  .size-small .ms-ChoiceField-field {
    font-size: 12px !important;
  }

  .size-small.fui-Input {
    min-height: 28px !important;
    height: 28px;
    padding-left: 4px;
    padding-right: 4px;
  }

  .TreeNodeWrapper .upIcon {
    transform: rotate(90deg);
  }

  .TreeNodeWrapper .blk-item {
    display: flex;
    align-items: center;
    height: 22px;
  }

  .TreeNodeWrapper .icon-isCollapsed {
    display: flex;
    align-items: center;
    width: 14px;
  }

  .TreeNodeWrapper .fui-Checkbox {
    margin-left: -4px;
  }

  .TreeNodeWrapper .ckb-custom {
    display: flex;
    cursor: pointer;
    align-items: center;
    height: 22px;
  }

  .TreeNodeWrapper .ckb-custom:hover {
    background: rgba(51, 51, 204, 0.1);
  }

  .TreeNodeWrapper .rct-icon {
    margin-top: 6px;
  }

  .TreeNodeWrapper .icon-info {
    display: flex;
    align-items: center;
    padding-top: 2px;
  }

  .TreeNodeWrapper .fui-Label {
    padding: 0 4px !important;
  }
  
  .TreeNodeWrapper .active {
    background-color: rgb(237, 235, 233);
  }

  .ml-12 {
    margin-left: 12px;
  }

  .LabelCheckbox {
    display: flex;
    align-items: center;
    margin-left: -6px;
  }

  .LabelCheckbox .text-label {
    display: flex;
    flex-direction: row;
  }

  .mlr-5 {
    margin-left: 5px;
    margin-right: 5px;
  }

  .custom-icon-label {
    display: flex;
    align-items: center;
    margin-right: 4px;
    margin-top: 2px;
  }

  .fui-Checkbox:focus {
    outline: none !important;
  }

  .fui-Checkbox:focus-within::after {
    border: none !important;
  }

  .input-icon-drd {
    cursor: pointer;
  }

  .input-icon-drd-disable {
    cursor: not-allowed;
  }

  .blk-choice-group {
    height: 35px;
    padding-left: 8px;
    border-bottom: 1px solid #e0e0e0;
  }
  .label_custom {
    font-size: ${(props) => (props.$isSmall ? "12px" : "14px")};
    white-space: nowrap;
    max-width: 150px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;

  }
`;

export const PopoverWrapper = styled.div<{ $isSmall?: boolean }>`
  .label_custom {
    font-size: ${(props) => (props.$isSmall ? "12px" : "14px")};
    white-space: nowrap;
    max-width: 150px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .fui-Checkbox__indicator {
    width: 12px !important;
    height: 12px !important;
  }

  .box-shadow-none {
    box-shadow: none !important;
  }

  .lbl_hide {
    display: none !important;
  }

  .input-locations-sl {
    width: 100%;
  }

  .active-location-tree > input {
    font-weight: 500;
  }

  .button-group-tree-location,
  .button-group-tree-location * {
    box-sizing: border-box;
  }

  .button-group-tree-location {
    background: #ffffff;
    border-radius: 0px 0px 2px 2px;
    border-style: solid;
    border-color: #c8c8c8;
    border-width: 0.5px 0px 0px 0px;
    width: 100%;
    height: 40px;
    position: relative;
    overflow: hidden;
  }

  .button-box-footer {
    background: #edebe9;
    width: 283.88px;
    height: 0.88px;
    position: absolute;
    left: 11.06px;
    top: -3.5px;
  }

  .frame-427322822 {
    display: flex;
    flex-direction: row;
    gap: 12px;
    align-items: center;
    justify-content: flex-start;
    position: absolute;
    right: 0px;
    top: 6px;
  }

  .reset-tree-location {
    color: #106ebe;
    text-align: left;
    font: 400 14px/20px "Segoe UI", sans-serif;
    text-decoration: underline;
    position: relative;
    cursor: pointer;
  }

  .frame-44 {
    background: #106ebe;
    border-radius: 2px;
    padding: 4px 12px 4px 12px;
    display: flex;
    flex-direction: row;
    gap: 8px;
    align-items: flex-start;
    justify-content: flex-start;
    flex-shrink: 0;
    position: relative;
  }

  .apply-tree-location {
    color: #ffffff;
    text-align: left;
    font: 600 14px/20px "Segoe UI", sans-serif;
    position: relative;
    cursor: pointer;
  }

  .input-locations-sl > input {
    &:hover {
      cursor: pointer;
    }
  }

  .pd-list {
    padding: 4px !important;
  }

  .size-small input {
    font-size: 12px;
    padding-left: 4px;
  }

  .size-small .fui-Input__contentBefore {
    margin-left: 3px;
  }

  .size-small .icon-horizontal {
    transform: rotate(270deg);
  }

  .size-small .fui-Label {
    font-size: 12px !important;
  }

  .size-small .ms-ChoiceField-field {
    font-size: 12px !important;
  }

  .size-small.fui-Input {
    min-height: 28px !important;
    height: 28px;
    padding-left: 4px;
    padding-right: 4px;
  }

  .TreeNodeWrapper .upIcon {
    transform: rotate(90deg);
  }

  .TreeNodeWrapper .blk-item {
    display: flex;
    align-items: center;
    height: 22px;
  }

  .TreeNodeWrapper .icon-isCollapsed {
    display: flex;
    align-items: center;
    width: 14px;
  }

  .TreeNodeWrapper .fui-Checkbox {
    margin-left: -4px;
  }

  .TreeNodeWrapper .ckb-custom {
    display: flex;
    cursor: pointer;
    align-items: center;
    height: 22px;
  }

  .TreeNodeWrapper .ckb-custom:hover {
    background: rgba(51, 51, 204, 0.1);
  }

  .TreeNodeWrapper .rct-icon {
    margin-top: 6px;
  }

  .TreeNodeWrapper .icon-info {
    display: flex;
    align-items: center;
    padding-top: 2px;
  }

  .TreeNodeWrapper .fui-Label {
    padding: 0 4px !important;
  }

  .TreeNodeWrapper .active {
    background-color: rgb(237, 235, 233);
  }

  .ml-12 {
    margin-left: 12px;
  }

  .LabelCheckbox {
    display: flex;
    align-items: center;
    margin-left: -6px;
  }

  .LabelCheckbox .text-label {
    display: flex;
    flex-direction: row;
    font-size: 12px;
  }

  .mlr-5 {
    margin-left: 5px;
    margin-right: 5px;
  }

  .custom-icon-label {
    display: flex;
    align-items: center;
    margin-right: 4px;
    margin-top: 2px;
  }

  .fui-Checkbox:focus {
    outline: none !important;
  }

  .fui-Checkbox:focus-within::after {
    border: none !important;
  }

  .input-icon-drd {
    cursor: pointer;
  }

  .input-icon-drd-disable {
    cursor: not-allowed;
  }

  .blk-choice-group {
    height: 35px;
    padding-left: 8px;
    border-bottom: 1px solid #e0e0e0;
  }
`;

export const ButtonApplyWrapper = styled.div<{ $theme?: string }>`
  border-top: 1px solid #e0e0e0;
  display: flex;
  justify-content: flex-end;
  padding-bottom: 8px;

  .btn-apply {
    margin-top: 8px;
    text-decoration: underline;
    color: ${(props) => renderColorPrimary(props.$theme)};
    font-size: 12px;
    font-weight: 400;
    padding: 0px 8px;
  }

  .btn-apply:hover {
    cursor: pointer;
  }

  .btn-apply:last-child {
    margin-right: 8px;
    background-color: ${(props) => renderColorPrimary(props.$theme)};
    color: #fff;
    text-decoration: unset;
    border-radius: 3px;
  }

  button {
    margin-top: 8px;
    margin-left: 8px;
    background-color: #106ebe;
    color: ${(props) => renderColorPrimary(props.$theme)};
    min-width: 0 !important;
  }

  button:first-child {
    background-color: transparent;
    border: unset;
    color: ${(props) => renderColorPrimary(props.$theme)};
  }
`;


export const TooltipWrapper = styled.div<{ $isSmall?: boolean }>`
  .label_custom {
    font-size: ${(props) => (props.$isSmall ? "12px" : "14px")};
    white-space: nowrap;
    max-width: 150px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
  }
 
`;

